import Lomake from "@/components/02-organisms/Lomake";
import { useChangeObjectsByAnchorWithoutUnderRemoval } from "@/stores/muutokset";

const Kokeilulupa = () => {
  const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
    anchor: "kokeilulupa"
  });
  return (
    <Lomake
      anchor={"kokeilulupa"}
      changeObjects={changeObjects}
      mode="addition"
      isInExpandableRow={false}
      isReadOnly={false}
      path={["esittelija", "kokeilulupa"]}
    />
  );
};

export default Kokeilulupa;
